import { type MainTranslationFunction } from '@autone/translations';

import { type APP_NAME } from '../../../../consts';
import { type AssortmentCustomColumnsConfig } from '../AssortmentCustomColumnsMenu.types';

export const getSkuLocationsTableCustomColumnsConfig = (
  t: MainTranslationFunction<typeof APP_NAME>,
): AssortmentCustomColumnsConfig<'skuLocationsTable'> => {
  return {
    storageKey: 'skuLocationsTable.extrasMenu.customColumns',
    columnOptions: [
      {
        id: 'permanent',
        translatedDisplayName: t('custom-columns-groups.permanent'),
        columns: [
          {
            id: 'sku_product',
            translatedDisplayName: t('table-columns.product'),
          },
        ],
      },
      {
        id: 'attributes',
        translatedDisplayName: t('custom-columns-groups.attributes'),
        columns: [
          {
            id: 'size_sku',
            translatedDisplayName: t('table-columns.size'),
          },
          {
            id: 'location',
            translatedDisplayName: t('table-columns.location'),
          },
          {
            id: 'product_groups',
            translatedDisplayName: t.withCustomer(
              'table-columns.$product-groups',
            ),
          },
          {
            id: 'location_cluster',
            translatedDisplayName: t.withCustomer(
              'table-columns.$location-cluster',
            ),
          },
        ],
      },
      {
        id: 'assortment',
        translatedDisplayName: t('custom-columns-groups.assortment'),
        columns: [
          {
            id: 'current_assortment',
            translatedDisplayName: t('table-columns.current-assortment'),
          },
          {
            id: 'autone_recommendation',
            translatedDisplayName: t('table-columns.autone-recommendation'),
          },
          {
            id: 'initial_allocation',
            translatedDisplayName: t('table-columns.initial-allocation'),
          },
          {
            id: 'assorted_start_date',
            translatedDisplayName: t(
              'table-columns.scheduled-assortment-start',
            ),
          },
          {
            id: 'assorted_end_date',
            translatedDisplayName: t('table-columns.scheduled-assortment-end'),
          },
        ],
      },
      {
        id: 'sales',
        translatedDisplayName: t('custom-columns-groups.sales'),
        columns: [
          {
            id: 'total_sales_units',
            translatedDisplayName: t('table-columns.total-sales-units'),
          },
          {
            id: 'total_sales_value',
            translatedDisplayName: t('table-columns.total-sales-value'),
          },
          {
            id: 'first_sale_date',
            translatedDisplayName: t('table-columns.first-sale-date'),
          },
          {
            id: 'latest_sale_date',
            translatedDisplayName: t('table-columns.latest-sale-date'),
          },
        ],
      },
      {
        id: 'inventory',
        translatedDisplayName: t('custom-columns-groups.inventory'),
        columns: [
          {
            id: 'current_units',
            translatedDisplayName: t('table-columns.current-units'),
          },
          {
            id: 'pending_from_production_units',
            translatedDisplayName: t(
              'table-columns.pending-from-production-units',
            ),
          },
          {
            id: 'warehouse_units',
            translatedDisplayName: t('table-columns.warehouse-units'),
          },
          {
            id: 'parent_location_pending_from_production_units',
            translatedDisplayName: t(
              'table-columns.parent-location-pending-from-production-units',
            ),
          },
        ],
      },
    ],
    columnPinning: {
      leftPinned: ['sku_product', 'size_sku', 'location'],
    },
    permanentColumns: ['sku_product', 'size_sku', 'location'],
  } as const;
};
